import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en clases-calistenia-san-miguel-page.tsx y se descarga aparte
// (code-split) — así visitar el home u otra página pública no baja el bundle de esta (ver
// mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/clases-calistenia-san-miguel",
  head: () => ({
    meta: seoMeta({
      title: "Clases de Calistenia en San Miguel | Calistenia Progresiva",
      description: "Clases grupales de calistenia en San Miguel, en el Parque Plaza Artes Gráficas (Ramón Barros Luco 3969). Horarios y cómo llegar. Agenda tu primera clase.",
      path: "/clases-calistenia-san-miguel",
    }),
    links: [canonicalLink("/clases-calistenia-san-miguel")],
  }),
  component: lazyRouteComponent(() => import("./clases-calistenia-san-miguel-page"), "SedeSanMiguelPage"),
});
